import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {aifcPortalUrl} from "../../../../../shared-layout/navigation/aifc-portal-url";

interface SupportCard {
  /** i18n keys — the English strings double as translation keys. */
  titleKey: string;
  descriptionKey: string;
  prefix: string;
}

const SUPPORT_CARDS: SupportCard[] = [
  {
    titleKey: 'Registration Support',
    descriptionKey:
      'Get professional support with establishing and registering a company in the AIFC, including preparation and submission of registration documents.',
    prefix: 'REG_SUPPORT',
  },
  {
    titleKey: 'Post-registration Support',
    descriptionKey:
      'Get support with updates to your AIFC company details (address, CEO, shareholders, etc.) and ongoing obligations, including reporting, accounting and audit requirements.',
    prefix: 'POST_REG_SUPPORT',
  },
  {
    titleKey: 'Authorization Support',
    descriptionKey:
      'Find professional support with the AFSA licensing process, including preparation of an application, policies, and other supporting documentation.',
    prefix: 'AUTH_SUPPORT',
  },
  {
    titleKey: 'Support with AIFC Court/IAC',
    descriptionKey:
      'Find legal professionals who can provide advice and representation in matters involving the AIFC Court or International Arbitration Centre (IAC).',
    prefix: 'COURT_SUPPORT',
  },
];

/**
 * "ASP Marketplace / Need help?" block. Every card leads to the marketplace,
 * which now lives in front-ext itself (top-level src/app/marketplace/, a
 * public route — not under /portal) — an in-app navigate instead of the
 * aifc-portal cross-domain redirect this used before the port.
 */
@Component({
  selector: 'app-landing-support',
  templateUrl: './landing-support.component.html',
  styleUrls: ['./landing-support.component.scss'],
  imports: [CommonModule, TranslateModule, NzIconModule],
})
export class LandingSupportComponent {
  private readonly router = inject(Router);

  public readonly cards = SUPPORT_CARDS;

  // public openMarketplace(card: SupportCard): void {
  //   this.router.navigate(['/marketplace'], {
  //     queryParams: { service: card.prefix }
  //   });
  // }


  public openMarketplace(card: SupportCard): void {
    window.location.href = aifcPortalUrl(`/marketplace?service=${card.prefix}`);
  }
}
